<template>
  <div class="page clearfix" v-wechat-title="$route.meta.title='推广介绍'">
    <img class="logo" src="../../assets/extend_logo.png" alt="">
    <div class="extend_img02 clearfix">
      <img class="fl extend_img021" src="../../assets/extend_img02.png" alt="">
      <img class="extend_img03" src="../../assets/extend_img03.png" alt="">
    </div>
    <div class="extend_step clearfix">
      <img class="fl extend_step_img" src="../../assets/extend_img04.png" alt="">
      <img class="extend_step_bj" src="../../assets/extend_img03.png" alt="">
    </div>
    <div class="extend_step clearfix">
      <img class="fl extend_step_img" style="margin-top: -.3rem;" src="../../assets/extend_img05.png" alt="">
      <img class="extend_step_bj" src="../../assets/extend_img03.png" alt="">
    </div>
    <div class="extend_step clearfix">
      <img class="fl extend_step_img" style="margin-top: -.3rem;" src="../../assets/extend_img06.png" alt="">
    </div>
    <div class="extend_btn" @click="goExtend">{{btnText}}</div>
  </div>

</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import { mapState, mapMutations } from 'vuex'
  import {getIsRegister} from "@/service/getData";
  import {wxShareme} from '@/utils/wechat'
  import {getServer} from '@/utils/share'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        TimeStamp: new Date().getTime(),  //获取当前时间
        userInfo: {},
        btnText:'立即申请'
      }
    },
    computed: {

    },
    created() {
      this.initData();
    },
    beforeDestroy(){
      window.removeEventListener("scroll", function () {});
    },
    methods: {
      async initData(){
        //判断是否注册
        let res = await getIsRegister({
          openid: getStore("userInfo").openid
        });
        if (res.errcode == '00000') {
          if(res.data == true){
            this.btnText = '立即登录'
          }else{
            this.btnText = '立即申请'
          }
        }
        let title = '金牌解说 | 佣金大放送，推广即挣钱！';
        let desc = '申请金牌解说推广顾问，分享历史故事还能佣金~';
        let link = '/extend-index';
        wxShareme(title,desc,"",link);
      },
      //推广登录
      goExtend(){
        this.$router.push({
          path: `/extend-login`
        });
      },
    },
    components: {

    },

  }

</script>

<style scoped>

  .page{ position: relative; width: 100%;padding-bottom: 1.9rem; background: #ffaa00; text-align:center;overflow-x: hidden;}
  .logo{width:69.86%;height:auto;margin-top: 1.4rem;}
  .extend_img02{position: relative;width:4.59rem;margin:.7rem auto 0;}
  .extend_img02 .extend_img021{position: relative;width:100%;height:auto;z-index: 2;}
  .extend_img02 .extend_img03{position: absolute;left:50%;top:100%;width:3.68rem;height:.84rem;margin-left: -1.84rem;margin-top:-.3rem;background: url(../../assets/extend_img03.png) no-repeat center;background-size: 100% auto;z-index: 1;}
  .extend_step{position: relative;width: 92.9%;margin:.2rem auto 0;}
  .extend_step_img{width: 100%;height:auto;}
  .extend_step_bj {position: absolute;left:50%;bottom:-.26rem;width:3.68rem;height:.84rem;margin-left: -1.84rem;background: url(../../assets/extend_img03.png) no-repeat center;background-size: 100% auto;z-index: 1;}
  .extend_btn{position:fixed;left:0;bottom:0;width:100%;height:1.2rem;line-height: 1.2rem;text-align: center;font-size: .34rem;color: #fff;letter-spacing: .04rem;background: #ff5d36;z-index: 3;}
</style>



// WEBPACK FOOTER //
// src/page/extend-index/extend-index.vue